<div
  class="mb-2 card-collapse-arrow"
  [ngClass]="{ 'collapsed': isEmpCardsCollapsed }">
  <button
    class="btn-reset"
    (click)="onOpenEmpCards()"
    id="onOpenEmpCards"
    [attr.aria-expanded]="!isEmpCardsCollapsed"
    aria-controls="collapseEmpCards">
    <app-fund-account-balance-widget
      [isFundAccount]="true"
      [displayData]="displayData()"></app-fund-account-balance-widget>
  </button>
  <div
    #EmpCardCollapse="ngbCollapse"
    [(ngbCollapse)]="isEmpCardsCollapsed">
    <div class="card card-info border-0 mt-2">
      <div class="card-body">
        @if (fundAccountDetails()) {
          <ng-container
            [ngTemplateOutlet]="bankDetails"
            [ngTemplateOutletContext]="{
              details: fundAccountDetails()?.physical_account,
              ref: fundAccountDetails()?.physical_eft_ref,
              type: 'physical employee',
            }"></ng-container>
        } @else {
          <app-loader></app-loader>
        }
      </div>
    </div>
  </div>
</div>

<div
  class="mb-2 card-collapse-arrow"
  [ngClass]="{ 'collapsed': isSubCardsCollapsed }">
  <button
    class="btn-reset"
    (click)="onOpenSubCards()"
    id="onOpenSubCards"
    [attr.aria-expanded]="!isSubCardsCollapsed"
    aria-controls="collapseSubCards">
    <app-fund-account-balance-widget
      [isEmployeeCardBalance]="false"
      [isFundAccount]="true"
      [displayData]="displayData()"></app-fund-account-balance-widget>
  </button>
  <div
    #SubCardCollapse="ngbCollapse"
    [(ngbCollapse)]="isSubCardsCollapsed">
    <div class="card card-info border-0 mt-2">
      <div class="card-body">
        @if (fundAccountDetails()) {
          <ng-container
            [ngTemplateOutlet]="bankDetails"
            [ngTemplateOutletContext]="{
              details: fundAccountDetails()?.virtual_account,
              ref: fundAccountDetails()?.virtual_eft_ref,
              type: 'virtual subscription',
            }"></ng-container>
        } @else {
          <app-loader></app-loader>
        }
      </div>
    </div>
  </div>
</div>

<ng-template
  #bankDetails
  let-details="details"
  let-ref="ref"
  let-type="type">
  <div class="alert alert-light p-3 text-body">
    <div class="row align-items-center">
      <div class="col-auto">
        <div class="icon-rounded small-icon bg-white">
          <i class="iconoir-info-circle"></i>
        </div>
      </div>
      <div class="col">
        <p class="mb-0 fw-semibold">Use the payment details below to fund your {{ type }} cards.</p>
        <p class="mb-0">
          Your balance will be updated here once it reflects in the bank account below. Please note that depending on
          your bank, transfers can take up to 48 hours to reflect.
        </p>
      </div>
    </div>
  </div>
  <div class="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-2">
    <div class="col">
      <app-info-block
        label="Business Name"
        [value]="details.acc_name"></app-info-block>
    </div>
    <div class="col">
      <app-info-block
        label="Bank"
        [value]="details.bank"></app-info-block>
    </div>
    <div class="col">
      <app-info-block
        label="Account Type"
        [value]="details.acc_type"></app-info-block>
    </div>
    <div class="col">
      <app-info-block
        label="Branch Code"
        [value]="details.branch"
        [showCopyClipboard]="true"></app-info-block>
    </div>
    <div class="col">
      <app-info-block
        label="Account Number"
        [value]="details.acc_number"
        [showCopyClipboard]="true"></app-info-block>
    </div>
    <div class="col">
      <app-info-block
        label="Payment Reference"
        [value]="ref"
        [showCopyClipboard]="true"></app-info-block>
    </div>
  </div>
</ng-template>
